import { gtag } from "./googleAnalytics";
import { keygen, KeygenResult, solvers } from "./keygen";

let form: HTMLFormElement;
let serialInput: HTMLInputElement;
let brandSelect: HTMLSelectElement;
let resultCard: HTMLElement;
let resultBrand: HTMLElement;
let resultSerial: HTMLElement;
let resultMethod: HTMLElement;
let passwordDisplay: HTMLElement;
let copyButton: HTMLButtonElement;
let answerElement: HTMLDivElement;
let multipleResults: HTMLElement;
let multipleResultsList: HTMLElement;

function initElements(): void {
    form = document.getElementById("form_id") as HTMLFormElement;
    serialInput = document.getElementById("serial_id") as HTMLInputElement;
    brandSelect = document.getElementById("brand_select") as HTMLSelectElement;
    resultCard = document.getElementById("result_card") as HTMLElement;
    resultBrand = document.getElementById("result_brand") as HTMLElement;
    resultSerial = document.getElementById("result_serial") as HTMLElement;
    resultMethod = document.getElementById("result_method") as HTMLElement;
    passwordDisplay = document.getElementById("password_display") as HTMLElement;
    copyButton = document.getElementById("copy_button") as HTMLButtonElement;
    answerElement = document.getElementById("answer") as HTMLDivElement;
    multipleResults = document.getElementById("multiple_results") as HTMLElement;
    multipleResultsList = document.getElementById("multiple_results_list") as HTMLElement;

    if (!form || !serialInput || !brandSelect || !resultCard) {
        console.error("Gerekli form elementleri bulunamadı!");
        return;
    }
}

// Marka eşleştirme
const brandMapping: {[key: string]: string[]} = {
    "sony": ["sony"],
    "dell": ["dell", "hdd"],
    "asus": ["asus"],
    "hp": ["hp", "hewlett", "compaq"],
    "compaq": ["compaq", "hewlett"],
    "samsung": ["samsung"],
    "fujitsu": ["fujitsu", "fsi"],
    "insyde": ["insyde", "acer"],
    "phoenix": ["phoenix"]
};

function getBrandName(biosName: string): string {
    const lowerName = biosName.toLowerCase();
    if (lowerName.includes("sony")) return "SONY";
    if (lowerName.includes("dell")) return "DELL";
    if (lowerName.includes("asus")) return "ASUS";
    if (lowerName.includes("hp") || lowerName.includes("hewlett") || lowerName.includes("compaq")) return "HP";
    if (lowerName.includes("samsung")) return "SAMSUNG";
    if (lowerName.includes("fujitsu") || lowerName.includes("fsi")) return "FUJITSU-SIEMENS";
    if (lowerName.includes("insyde") || lowerName.includes("acer")) return "INSYDE H20";
    if (lowerName.includes("phoenix")) return "PHOENIX";
    return biosName.toUpperCase();
}

function getMethodDescription(solver: any): string {
    const biosName = solver.biosName.toLowerCase();
    if (biosName.includes("sony")) {
        if (biosName.includes("4x4")) {
            return "Sony 4x4 hexadecimal algoritması";
        }
        return "Sony 7 digit serial algoritması";
    }
    if (biosName.includes("dell")) {
        if (biosName.includes("hdd")) return "Dell HDD serial algoritması";
        if (biosName.includes("latitude")) return "Dell Latitude 3540 Insyde algoritması";
        return "Dell Service Tag algoritması";
    }
    if (biosName.includes("asus")) return "ASUS BIOS tarih algoritması";
    if (biosName.includes("hp") || biosName.includes("hewlett") || biosName.includes("compaq")) {
        if (biosName.includes("mini")) return "HP Mini Netbook algoritması";
        if (biosName.includes("insyde")) return "HP Insyde H20 algoritması";
        if (biosName.includes("ami")) return "HP AMI BIOS algoritması";
        return "HP/Compaq 5 digit algoritması";
    }
    if (biosName.includes("samsung")) return "Samsung hexadecimal algoritması";
    if (biosName.includes("fujitsu") || biosName.includes("fsi")) return "Fujitsu-Siemens algoritması";
    if (biosName.includes("insyde") || biosName.includes("acer")) return "Insyde H20 algoritması";
    if (biosName.includes("phoenix")) return "Phoenix generic algoritması";
    return solver.description || "Bilinmeyen algoritma";
}

function filterByBrand(results: KeygenResult[], selectedBrand: string): KeygenResult[] {
    if (!selectedBrand) return results;
    
    const brandKeywords = brandMapping[selectedBrand.toLowerCase()] || [];
    return results.filter(([solver]) => {
        const biosName = solver.biosName.toLowerCase();
        return brandKeywords.some(keyword => biosName.includes(keyword));
    });
}

function renderResult(results: KeygenResult[]): void {
    if (results.length === 0) {
        resultCard.classList.remove("show");
        return;
    }

    // İlk sonucu göster
    const [solver, passwords] = results[0];
    const brand = getBrandName(solver.biosName);
    const method = getMethodDescription(solver);
    const password = passwords[0] || "";

    resultBrand.textContent = brand;
    resultSerial.textContent = serialInput.value;
    resultMethod.textContent = method;
    passwordDisplay.textContent = password;

    // Çoklu gösterim - birden fazla sonuç varsa göster
    multipleResultsList.innerHTML = "";
    if (results.length > 1) {
        // Tüm sonuçları listele (ilk hariç)
        results.slice(1).forEach(([solver, passwords]) => {
            passwords.forEach((pwd) => {
                const resultItem = document.createElement("div");
                resultItem.className = "result-item";
                
                const nameDiv = document.createElement("div");
                nameDiv.className = "result-item-name";
                nameDiv.textContent = solver.description || getMethodDescription(solver);
                
                const passwordDiv = document.createElement("div");
                passwordDiv.className = "result-item-password";
                passwordDiv.textContent = pwd;
                
                const copyBtn = document.createElement("button");
                copyBtn.className = "result-item-copy";
                copyBtn.textContent = "Kopyala";
                copyBtn.onclick = () => copyPassword(pwd, copyBtn);
                
                resultItem.appendChild(nameDiv);
                resultItem.appendChild(passwordDiv);
                resultItem.appendChild(copyBtn);
                
                multipleResultsList.appendChild(resultItem);
            });
        });
        multipleResults.style.display = "block";
    } else if (passwords.length > 1) {
        // Aynı solver'dan birden fazla şifre varsa
        passwords.slice(1).forEach((pwd) => {
            const resultItem = document.createElement("div");
            resultItem.className = "result-item";
            
            const nameDiv = document.createElement("div");
            nameDiv.className = "result-item-name";
            nameDiv.textContent = solver.description || getMethodDescription(solver);
            
            const passwordDiv = document.createElement("div");
            passwordDiv.className = "result-item-password";
            passwordDiv.textContent = pwd;
            
            const copyBtn = document.createElement("button");
            copyBtn.className = "result-item-copy";
            copyBtn.textContent = "Kopyala";
            copyBtn.onclick = () => copyPassword(pwd, copyBtn);
            
            resultItem.appendChild(nameDiv);
            resultItem.appendChild(passwordDiv);
            resultItem.appendChild(copyBtn);
            
            multipleResultsList.appendChild(resultItem);
        });
        multipleResults.style.display = "block";
    } else {
        multipleResults.style.display = "none";
    }

    resultCard.classList.add("show");
    
    // Sayfayı sonuç kartına kaydır
    resultCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

function copyPassword(password: string, button: HTMLButtonElement): void {
    navigator.clipboard.writeText(password).then(() => {
        const originalText = button.textContent;
        button.textContent = "✓ Kopyalandı!";
        button.style.background = "#4CAF50";
        setTimeout(() => {
            button.textContent = originalText;
            button.style.background = "";
        }, 2000);
    }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = password;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
            const originalText = button.textContent;
            button.textContent = "✓ Kopyalandı!";
            button.style.background = "#4CAF50";
            setTimeout(() => {
                button.textContent = originalText;
                button.style.background = "";
            }, 2000);
        } catch (err) {
            alert("Kopyalama başarısız. Şifreyi manuel olarak kopyalayın: " + password);
        }
        document.body.removeChild(textArea);
    });
}

function trackResult(serial: string): KeygenResult[] {
    let result = keygen(serial);
    if (GOOGLE_ANALYTICS_TAG) {
        let eventParams: {[key: string]: boolean} = {};
        solvers.forEach((solver) => {
            eventParams[solver.biosName] = false;
        });

        result.forEach(([solver, _, time]) => {
            eventParams[solver.biosName] = true;

            // send calculation timing report
            gtag("event", "timing_complete", {
                "name": "bios_keygen",
                "value": Math.round(time),
                "event_category": solver.biosName
            });
        });

        // send event about calculation
        gtag("event", "bios_keygen", eventParams);
    }
    return result;
}

function handleFormSubmit(event?: Event): void {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    
    const serial = serialInput.value.trim();
    if (!serial) {
        alert("Lütfen bir serial number veya kod girin!");
        return;
    }

    if (answerElement) {
        answerElement.innerHTML = "";
    }
    
    let results = trackResult(serial);
    
    // Marka filtresi uygula
    const selectedBrand = brandSelect.value;
    if (selectedBrand) {
        results = filterByBrand(results, selectedBrand);
    }
    
    if (results.length > 0) {
        renderResult(results);
    } else {
        if (resultCard) {
            resultCard.classList.remove("show");
        }
        alert("Bu kod için şifre bulunamadı. Lütfen kodunuzu kontrol edin veya farklı bir marka seçin.");
    }
}

function setupEventListeners(): void {
    if (!form || !serialInput || !brandSelect || !copyButton) {
        console.error("Form elementleri eksik!");
        return;
    }

    // Şifre kopyalama (ana buton)
    copyButton.addEventListener("click", () => {
        const password = passwordDisplay.textContent;
        if (password && password !== "-") {
            copyPassword(password, copyButton);
        }
    });

    // Form submit event
    form.addEventListener("submit", handleFormSubmit);
    
    // Butona da direkt click event ekle (güvenlik için)
    const submitButton = document.getElementById("button_id") as HTMLButtonElement;
    if (submitButton) {
        submitButton.addEventListener("click", (e) => {
            e.preventDefault();
            handleFormSubmit();
        });
    }

    // Marka seçimine göre placeholder güncelle
    brandSelect.addEventListener("change", () => {
        const selectedBrand = brandSelect.value;
        const placeholders: {[key: string]: string} = {
            "sony": "Örn: 1234567",
            "dell": "Örn: 1234567-595B",
            "asus": "Örn: 01-02-2013",
            "hp": "Örn: 12345",
            "compaq": "Örn: 12345",
            "samsung": "Örn: 07088120410C0000",
            "fujitsu": "Örn: 12345 veya DEADBEEF",
            "insyde": "Örn: 03133610",
            "phoenix": "Örn: 12345"
        };
        
        serialInput.placeholder = placeholders[selectedBrand] || "Örn: 1234567 veya 1234567-595B";
    });
}

// DOM yüklendiğinde başlat
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        initElements();
        setupEventListeners();
    });
} else {
    // DOM zaten yüklenmiş
    initElements();
    setupEventListeners();
}
